import logo from '../logo.png';
import amber_warn from '../amber-circle-warning.png';
import red_warn from '../red-triangle-warning.png';

import { Radikle } from '../Components/Radikle';
import axios from "axios"

import RadikleSignInButtonV2 from '../Components/RadikleSignInButtonV2'; 

import GoogleSignInButton from '../Components/GoogleSignInButton'; 

import { useNavigate } from "react-router-dom";

import { useState, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';


import { useLoading } from "../Contexts/LoadingContext";

import { Modal } from '../Components/Modal';

import { AUTH_CLIENT, OAUTH_URI, API_BASE_URI, API_URI, ACCOUNTS_URI, APP_URI } from '../config/constants';

import { useUser } from "../Contexts/UserContext";


export function Login() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const [searchParams, setSearchParams] = useSearchParams();
  const authorization_code = searchParams.get("authorization_code");
  const state = searchParams.get("state");


  const { updateJWT, updateScopes, updateEmailAddress, updateUserSessionId } = useUser();

  const [email, setEmail] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [password, setPassword] = useState('');
  let [validEmail, setValidEmail] = useState(false);
  


  const [infoModal, setInfoModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const onModalClose = () => {
   
  }

  const handleEmailChange = (e) => {
    validateEmail(e);
    setEmail(e.target.value);
  };

  const handleFirstnameChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleLastnameChange = (e) => {
    setLastname(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const [pageState, setPageState] = useState("Login");

  const oauthConfig = {
    authorizationEndpoint: OAUTH_URI + "/authorize-self",
    tokenEndpoint: OAUTH_URI + "/token",
    clientId: AUTH_CLIENT,
    responseType: "CODE",
    redirectUri: ACCOUNTS_URI + "/#/login",
    scope: "rdkl:openid rdkl:profile rdkl:email rdkl:apis", // Note: when clientId and org are same, there will be
                                        // implicit scopes that are allowed for the client's BFFE
                                        // with client secret, but not for direct access from browser
    // Note: Orgs are defined part of the scope - Above: rdkl is the organization id.
    //orgs: ["radikle"] // Organizations to access for user's resource via API
    // Note: Client's own resource server will be its BFFE and parent org - default initial scopes.
    // Futher scopes of other orgs and resource servers can be obtained on need basis. Subsequent steps.
  };

  var generateNonce = require('../scripts/Utils.js').generateNonceBase64;
  var generateState = require('../scripts/Utils.js').generateState;

  async function authorize() {
    let clientRedirect = sessionStorage.getItem("CLIENT_REDIRECT");
    let authorizationInitialized = sessionStorage.getItem("AUTHORIZATION_INITIALIZED");

    if(clientRedirect != 'true' && authorizationInitialized != 'true') {
        console.log("INFO: This session is not for a Client and authorization is not Initialized yet. Hence making auth call.");
        let codeChallenge = sessionStorage.getItem("pkce_code_challenge");
        let codeChallengeMethod = sessionStorage.getItem("pkce_code_challenge_method");
        console.log("INFO: Preparing PKCE for authorize call with code challenge and code challenge method.");
        let state = generateState("welcome");
        let nonce = generateNonce();
        sessionStorage.setItem("state", state);
        sessionStorage.setItem("nonce", nonce);
        let clientSessionId = getUserClientSessionId();
        let authorizationUrl = `${oauthConfig.authorizationEndpoint}`+
                              `?response_type=${oauthConfig.responseType}`+
                              `&client_id=${oauthConfig.clientId}`+
                              `&redirect_uri=${encodeURIComponent(oauthConfig.redirectUri)}`+
                              `&scope=${encodeURIComponent(oauthConfig.scope)}`+
                              `&code_challenge=${codeChallenge}`+
                              `&code_challenge_method=${codeChallengeMethod}`+
                              `&client_session_id=${clientSessionId}`+
                              `&nonce=${nonce}&state=${state}`;
        
        axios.defaults.withCredentials = true;
        const response = await axios.get(authorizationUrl);

        if (response.status === 200) {
          sessionStorage.setItem("AUTHORIZATION_INITIALIZED", true);
          let sessionID = response.data;
          setUserSessionId(sessionID);
        }

    }
    else {
      console.log("INFO: Either this session is for a Client OR authorization is already Initialized. Hence no auth call made.");
    }
  }

  async function redirectToRadikleOAuth() {
      await authorize();
      
      let authorizationInitialized = sessionStorage.getItem("AUTHORIZATION_INITIALIZED");

      if(authorizationInitialized != 'true')
        return;

      if (validEmail ===  false) {
        displayWarning("Email format is invalid");
      }
      else if(pageState === 'Authcode') {
        console.log("INFO: Login requested with credentials");
        if(password == null || password.trim() === '') {
          displayWarning("Pass Code is required");
        }
        else {
          authenticate(email, password);
        }
      }
      else {
        console.log("INFO: Radikle Auth Code requested for Login");
        getAuthCode(email);
      }
  }

  function handleRegister() {
    console.log('INFO: Registration requested for: '+validEmail);
    if (firstname ===  '' && lastname === '') {
      displayWarning("Name is mandatory");
    }
    else {
      registerUser(email, firstname, lastname);
    }
  }

  function getAuthCode(email_address) {
    loginUser(email_address, null, 'GET_AUTH_CODE');
  }

  function authenticate(email_address, password) {
    loginUser(email_address, password, 'AUTHENTICATE');
  }

  async function  loginUser(email_address, password, action) {
    setLoading(true);
    let userSessionId = getUserSessionId();
    await axios.post(API_URI + "/user/login", {email_address, password, userSessionId, action}, { withCredentials: true })
      .then((response) => {
        setLoading(false);
        console.log("INFO: Response received for login endpoint ");
        handleResponse(response);
      }).catch((error) => {
        setLoading(false);
        console.log("ERROR: upon calling login endpoint" + error.message);
        handleResponse(error.response);
      });
  }

  async function authorizedUser(authorizationCode) {
    setLoading(true);
    let authorizedUrl = OAUTH_URI + "/authorized";
    let userSessionId = getUserSessionId();
    await axios.post(authorizedUrl, {userSessionId, authorizationCode}, { withCredentials: true })
      .then((response) => {
        setLoading(false);
        console.log("INFO: Response received for authorized endpoint ");
        handleResponse(response);
      }).catch((error) => {
        setLoading(false);
        console.log("ERROR: upon calling authorized endpoint" + error.message);
        handleResponse(error.response);
        displayModalMessage(error);
      });
  }

  async function registerUser(email_address, first_name, last_name) {
    const response = await axios.post(API_URI + "/user/register-user", {email_address, first_name, last_name});
      console.log(response)
      if (response.status === 200) {
        handleResponse(response);
      }
      else {
        handleError(response);
      }
  }

  function displayModalMessage(mssg) {
    setModalMessage(mssg);
    setInfoModal(true);
  }

  function handleError(response) {
    displayWarning("ERROR: with status: "+response.status+
      " "+response.data.responseCode);
    navigate("/error");
  }

  function resetEmail() {
    setPageStateLogin();
  }

  function setPageStateAuthcode(response) {
    setPageState('Authcode')
    displayWarning("Pass Code is sent in email.");
    if(email == null && response.data.responseData.email) {
      setEmail(response.data.responseData.email);
    }
  }

  function setPageStateLogin() {
    setPageState('Login');
  }

  function setPageStateRegister() {
    setPageState('Register');
    displayWarning("Register User.");
  }

  function handleResponse(response) {
    if(response == null || response.data == null) {
      return;
    }
    if(response.data.responseCode === 7000) {
      setPageStateRegister();
    }
    if(response.data.responseCode === 2222) {
      setPageStateAuthcode(response);
    }
    if(response.data.responseCode === 7401) {
      //setPageStateLogin();
      //displayModalMessage("Invalid Credentials");
      setPassword('');
      displayWarning("Invalid Credentials");
    }
    if(response.data.responseCode === 2200) {/*

      let jwt = response.data.responseData.JWT;
      sessionStorage.setItem("jwt", jwt);
      navigate("/welcome"); */
      
    }
    if(response.data.responseCode === 2220) {
      let authorizationCode = response.data.responseData.AuthorizationCode;
      // This is the final call to redirect successful login. 
      // There could be scope selection page after successful login and before redirection.
      // Hence this explicit step is included.
      authorizedUser(authorizationCode);
    }
    if(response.data.responseCode === 3220) {
      let requestedScopes = response.data.responseData.requestedScopes;
      let emailAddress = response.data.responseData.emailAddress;
      console.log(requestedScopes);
      console.log(emailAddress);
      updateScopes(requestedScopes);
      updateEmailAddress(emailAddress);
      navigate('/scopes');
    }    
    else if(response.data.responseCode === 2230) {
      let authorizationRedirection = response.data.responseData.AuthorizationRedirection;
      window.location.href = authorizationRedirection;    
    }
  }

  function decodeJwt(token) {
    // Split token into parts
    const [header, payload] = token.split('.');

    if (!header || !payload) {
      throw new Error('Invalid JWT format.');
    }

    // Base64-URL decode
    const base64UrlDecode = (str) =>
      decodeURIComponent(atob(str.replace(/-/g, '+').replace(/_/g, '/'))
      .split('')
      .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
      .join(''));

    const decodedHeader = JSON.parse(base64UrlDecode(header));
    const decodedPayload = JSON.parse(base64UrlDecode(payload));

    console.log('INFO: Header and Payload from JWT obtained successfully');
    return { header: decodedHeader, payload: decodedPayload };
  }
  
  function handleTokenResponse(response) {
    if(response != null && response.responseCode === 2200) {
      try {
        let jwt = response.responseData.JWT;
        let decodedjwt = decodeJwt(jwt);
        let decodedPayload = decodedjwt.payload;
        const tokenNonce = decodedPayload.nonce; // Extract nonce from the token
        const sessNonce = sessionStorage.getItem("nonce")
        if(tokenNonce !== sessNonce) {
          console.log("ERROR: Nonce mismatch.");
          navigate("/error");
        }
        else {
          console.log("INFO: Nonce match confirmed.")
        }

        sessionStorage.setItem("jwt", jwt);
        updateJWT(jwt);
        navigate("/welcome");
      }
      catch(err) {
        console.error('ERROR: While handling Token Response:', err.message);
      }
    }
    else {
      console.log("ERROR: while requesting for Token.");
      handleError(response);
    }
  }

  function displayWarning(warningMessage) {
    let x = document.getElementById("info-div");
    let xx = document.getElementById("info-text-label");
    let xxx = document.getElementById("warn-img");

    xxx.hidden = false;
    xx.innerHTML = warningMessage;
    x.classList.add('info-text-animate');

    let y = document.getElementById("login-div");
    y.classList.add('login-container');
    setTimeout(function() {
      y.classList.remove('login-container');
    }, 1000); 

    setTimeout(function() {
      x.classList.remove('info-text-animate');
      xx.innerHTML = "";
      xxx.hidden = true;
    }, 4000);
  }
  
  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  const validateEmail = (e) => {
    if(e.target?.value && e.target.value.match(isValidEmail)){
      setValidEmail(true);
    }else {
      setValidEmail(false);
    }
  }

  function isReadOnly() {
    return (pageState !== 'Login')
  }

  async function redirectToGoogleOAuth() {
      await authorize();
      const clientId = "828330010124-8i078j070m14idjmsmkdqk82fk2cmn9p.apps.googleusercontent.com";

      const redirectUri = ACCOUNTS_URI + "/auth/callback";
      const scope = "openid email profile";
      let userSessionId = getUserSessionId();
      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${userSessionId}`;
      window.location.href = authUrl;
  }

  function setUserSessionId(userSessionId) {
    sessionStorage.setItem("User-Session-ID", userSessionId);
    updateUserSessionId(userSessionId);
  }

  function getUserSessionId() {
    return sessionStorage.getItem("User-Session-ID");
  }

  function getUserClientSessionId() {
    return sessionStorage.getItem("User-Client-Session-ID");
  }

  useEffect(() => {
    // Search Params Start****
    const params = new URLSearchParams(window.location.hash.split('?')[1]);
    let userSessionId = searchParams.get("user_session_id");
    console.log("User Session ID obtained in Search Params:" + userSessionId);
    if(userSessionId) {
      setUserSessionId(userSessionId);
      //navigate('/login');
    }
    console.log("User Session ID obtained in URL Search Params:" + params.get("user_session_id"));
    // Search Params End ****

    if (authorization_code) {
      console.log("INFO: 'authorization_code' obtained from Search Params" );
      // Authorization Code received for further token request within Radikle oAuth.
      setLoading(true);
      try {
        let sessState = sessionStorage.getItem("state");
        // State stored in client session must match the one returned by auth server.
        if(state !== sessState) {
          console.log("ERROR: State mismatch.");
          navigate("/error");
        }
        else {
          console.log("INFO: State Match Confirmed.");
        }
        // Obtain Access Token with the authorization code.
        getToken(authorization_code, ACCOUNTS_URI + "/#/login", "radikle", userSessionId,
                  API_URI + "/user/token");
      } catch (error) {
        console.error('ERROR: Failed to fetch token:', error);
      }
      finally {
        setLoading(false);
      }
    }
    else {
      let jwt = sessionStorage.getItem("jwt");
      //showParams();
      if(jwt != null) {
        console.log('INFO: User is Authenticated. Redirect to Welcome!');
        // Redirect to Welcome! page of accounts.radikle.com or app.radikle.com based on context.
        //window.location.href = redirect_uri;
        navigate('/welcome');
      }
    }
      
    }, [authorization_code] // Empty Dependency Array - 
          // Executed only once when the page launches but not on every re-render
  );  
  
  const retrieveDPoPKeyPairFromSessionStorage = require('../scripts/Utils.js').retrieveDPoPKeyPairFromSessionStorage;
  const exportDPoPKeyPair = require('../scripts/Utils.js').exportDPoPKeyPair;

  async function getToken(authCode, redirectUri, clientId, userSessionId, tokenEndpoint) {
    // Generate a key pair (for simplicity; in production, reuse keys)
    //const { publicKey, privateKey } = await generateKeyPair('ES256'); // EC256 is commonly used
    var dPoPKeyPair = await retrieveDPoPKeyPairFromSessionStorage();
    var jwkDPoPKeyPair = await exportDPoPKeyPair(dPoPKeyPair);

    const publicKeyJwk = jwkDPoPKeyPair.publicKeyJwk;
    const dpopProof = await createDpopProof(publicKeyJwk, dPoPKeyPair.privateKey, tokenEndpoint, "POST");
    const pkce_code_verifier = sessionStorage.getItem("pkce_code_verifier");
    const csrf_token = sessionStorage.getItem("User-Client-Session-CSRF-Token");

    // Step 2: Set up token request
    const params = new URLSearchParams({
      grant_type: 'authorization_code',
      code: authCode,
      redirect_uri: redirectUri,
      client_id: clientId,
      user_session_id: userSessionId,
      pkce_code_verifier: pkce_code_verifier
    });
  
    try {
      // Step 3: Send request
      /*
      const response = await axios.post(tokenEndpoint, {"authorizationCode": authorization_code, "clientPublicKey":sessionStorage.getItem("DPoP_Public_Key")}, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          'DPoP': dpopProof, // Include the DPoP proof header
        }, withCredentials: true
      });
      */

      const response = await fetch(tokenEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "DPoP": dpopProof,
          'X-CSRF-Token': csrf_token
        },
        credentials: 'include',
        body: params.toString(),
      });

      if (!response.ok) {
        throw new Error(`Token request failed: ${response.statusText}`);
      }
    
      const tokenResponse = await response.json();
      console.log("INFO: Token Response received.");

      handleTokenResponse(tokenResponse);
    } catch (error) {
      console.error('ERROR: Token request failed: ', error);
      navigate("/error");
    }
  }

  async function createDpopProof(publicKeyJWK, privateKey, htu, htm) {
    var htu = OAUTH_URI + "/token";
    const header = {
      alg: "ES256", // Algorithm: ECDSA with SHA-256
      typ: "dpop+jwt", // Type of token
      jwk: publicKeyJWK
    };

    const payload = {
      htm, // HTTP method (e.g., "POST")
      htu, // HTTP URI (e.g., "https://example.com/token")
      jti: crypto.randomUUID(), // Unique token ID
      iat: Math.floor(Date.now() / 1000), // Issued-at time
    };
  
    // Encode header and payload to base64url
    const encoder = new TextEncoder();
    const encodeBase64Url = (data) =>
      btoa(String.fromCharCode(...new Uint8Array(data)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");

    const headerBase64Url = encodeBase64Url(encoder.encode(JSON.stringify(header)));
    const payloadBase64Url = encodeBase64Url(encoder.encode(JSON.stringify(payload)));

    // Create the signing input (header + "." + payload)
    const signingInput = `${headerBase64Url}.${payloadBase64Url}`;

    // Sign the input with the private key
    const signature = await window.crypto.subtle.sign(
      {
        name: "ECDSA",
        hash: { name: "SHA-256" }, // Hash algorithm
      },
      privateKey,
      encoder.encode(signingInput)
    );

    const signatureBase64Url = encodeBase64Url(signature);

    // Combine all parts into the final DPoP JWT
    const dpopJwt = `${signingInput}.${signatureBase64Url}`;
    console.log("INFO: DPoP Proof has been created.");

    return dpopJwt;
  }

  return (
    <>
    <div>
      <Radikle/>
      <div className="TableContainer">
        <div className="Table">
        <div className="TableBody">
          <div className="TableRow" id="login-div">
            <div className="TableCellLeft">
              <label className="Email-label">Email</label>
            </div>
            <div className="TableCellRight">
              <input className="Email-field" type="text" autoComplete="off" value={email} onChange={handleEmailChange} readOnly={isReadOnly()}/>
            </div>
          </div>
          <div className="TableRow" id="password-div" hidden = {pageState !== 'Authcode'}>    
              <div className="TableCellLeft">
                <label className="Email-label">Pass Code</label>
              </div>
              <div className="TableCellRight">
                <input className="Email-field" type="password" value={password} onChange={handlePasswordChange}/>
              </div>
          </div>
          <div className="TableRow">
            <div className="TableCellLeft"/>
            <div className="TableCellRight">
              <div id="info-div" className="info-container" style={{marginBottom: '3em'}}>
                <img id="warn-img" className="logo-icon-small" src={amber_warn} alt="icon" hidden/>
                <label id="info-text-label" className="info-text"></label>
              </div>
            </div>
          </div>
          <div className="TableRow" hidden={pageState !== 'Authcode'}>
            <div className="TableCellLeft"/>
            <div className="TableCellRight">
              <button id="login-button" className="Login-button" onClick={redirectToRadikleOAuth}><span>Login</span></button>
            </div>
          </div>
          
          <div className="TableRow" hidden={pageState !== 'Login'}>
            <div className="TableCellLeft"/>
            <div className="TableCellRight">
              <RadikleSignInButtonV2 redirectToRadikleOAuth={redirectToRadikleOAuth}/>
            </div>
          </div>
          <div id="login-separator" className="TableRow" hidden={pageState !== 'Login'}>
            <div className="TableCellLeft"/>
            <div className="TableCellRight">
              <span>----------|----------</span>
            </div>
          </div>
          <div id="google-login" className="TableRow" hidden={pageState !== 'Login'}>
            <div className="TableCellLeft"/>
            <div className="TableCellRight">
              <GoogleSignInButton redirectToGoogleOAuth={redirectToGoogleOAuth}/>
            </div>
          </div>
        </div>
        </div>
      </div>

      <div id="registration-div" className="reg-container" hidden={pageState !== 'Register'}>
        <div className="TableContainer">
          <div className="Table">
            <div className="TableBody">
              <div className="TableRow">
                <div className="TableCellLeft">
                  <label className="Email-label">First Name</label>
                </div>
                <div className="TableCellRight">
                  <input className="Email-field" autoComplete="off" value={firstname} onChange={handleFirstnameChange}/>
                </div>
              </div>
              <div className="TableRow">
                <div className="TableCellLeft">
                  <label className="Email-label">Last Name</label>
                </div>
                <div className="TableCellRight">
                  <input className="Email-field" autoComplete="off" value={lastname} onChange={handleLastnameChange}/>
                </div>
              </div>
              <div className="TableRow">
                <div className="TableCellLeft"/>
                <div className="TableCellRight">
                  <button id="register-button" className="Login-button" onClick={handleRegister}><span>Register</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="reset-div" className="reset-container" hidden={pageState == 'Login'}>
        <button id="reset-button" className="Reset-button" onClick={resetEmail}><span>Sign in again</span></button>
      </div>
    </div>
    <Modal message={modalMessage} show={infoModal} setInfoModal={setInfoModal} onModalClose={onModalClose}></Modal>
    </>
  )
}
